<template>
    <div class="login-page-wrapper profile" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container ">
            <div class="row">
                <div class="col-md-12">
                    <div class="main-content">
                        <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor } ">FAQ</h3>
                    </div>
                </div>
                <div class="col-md-12 text-left" v-if="allFAQ" v-for="section in allFAQ">
                    <legend v-bind:style="{ color: getCorpHeadingColor } ">{{section.headerName}}</legend>
                    <div v-for="faq in section.lstFaqs">
                        <p>
                            <strong v-html="faq.question"></strong>
                        </p>
                        <p v-html="faq.response"></p>
                        <p v-if="faq.faqVideoUrl">
                            <a target="new" :href="faq.faqVideoUrl">Learn More</a>
                        </p>
                        <p v-if="faq.faqImageUrl">
                            <img :src="faq.faqImageUrl" />
                        </p>
                        <br>
                    </div>
                </div>
                <!--<div class="col-md-12 text-left" v-if="allFAQ">-->
                  <!--<legend>GENERAL</legend>-->
                    <!--<p>-->
                        <!--<strong>Why are you called TONE</strong>-->
                        <!--<strong>?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Because we to help you set the Tone of your day, and make it a better one:-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE is an online short-form video and social network for busy women who-->
                        <!--want to create their best lives and help others do the same. It’s a-->
                        <!--generous community within which to learn from experts, exchange advice, and-->
                        <!--be inspired.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Where are you located?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--The TONE HQ and Studio is located at 232 Madison Avenue, in New York City,-->
                        <!--but our Tone Team and experts are located throughout the US, and hail from-->
                        <!--around the world.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Who is your founder?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Gemma Toner is our founder. Gemma created TONE to give busy women the sense-->
                        <!--of satisfaction and joy that comes with giving and receiving help, guidance-->
                        <!--and advice.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>When did Tone launch?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE launched in October, 2017.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Is Tone a charity?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE is not a charity, but believes in spreading a ring of generosity and-->
                        <!--giving back. That’s why TONE sets aside a certain amount of money each year-->
                        <!--to give to charities and causes through Tone’s “Clicks for Good” program-->
                        <!--(See the Clicks for Good section below for more information)-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How can I get more involved with TONE</strong>-->
                        <!--<strong>?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Everyone is welcome at Tone and Tone encourages you to get more involved in-->
                        <!--our movement of women helping other women. Email at <a href="mailto:info@tonenetworks.com">info@tonenetworks.com.</a>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong><em> </em></strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Do you offer partnership opportunities?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes, TONE offers a flexible partnership model for businesses, brands and-->
                        <!--other organizations - please email inquiries to <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong><em> </em></strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong><em> </em></strong>-->
                    <!--</p>-->
                    <!--<legend>EXPERTS</legend>-->
                    <!--<p>-->
                        <!--<strong>-->
                            <!--What makes a TONE Expert an expert? What are the qualifications?-->
                        <!--</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE experts have made their subject matter their life’s passion. All Tone-->
                        <!--experts are vetted and credentialed and have partnered with Tone because-->
                        <!--they want to share their knowledge with you.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How does someone become a TONE expert, can I apply?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes, please send inquiries about becoming an expert to-->
                        <!--<a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How many experts are on TONE</strong>-->
                        <!--<strong>?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--The TONE network is always growing. We launched with 14 experts and are-->
                        <!--adding new experts on a monthly basis.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How many videos does a typical expert create?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Experts on average create 20 videos for TONE.-->
                    <!--</p>-->
                    <!--<legend>CONTENT</legend>-->
                    <!--<p>-->
                        <!--<strong>Does TONE produce the videos?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes all expert video content on TONE is original and produced in house in-->
                        <!--TONE’s own production studio.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Why do I receive 2 content emails a week?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Our members benefit from our time-saving philosophy of delivering “Sound-->
                        <!--Bites with Substance.” We believe you should spend more time learning than-->
                        <!--searching, so twice a week we send you carefully curated videos based on-->
                        <!--your interests.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Why do I receive </strong>-->
                        <!--<strong>“TONE Takeaways?” after watching videos? Can I opt out?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--For each video that you watch 70% or more, we send you TONE Takeaways as-->
                        <!--actionable summaries to inspire and remind you the next day. You can opt-->
                        <!--out by sending an email to    <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a> or-->
                        <!--clicking Unsubscribe at the base of all emails.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How is my content recommended for me?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Tone carefully curates recommendations based on the interests you have-->
                        <!--selected, the videos you have watched previously, and your online feedback.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How do you pick content subjects and topics?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE covers a range of topics important to women: personal coaching,-->
                        <!--professional development, finance, nutrition, fitness, and mindfulness. We-->
                        <!--also use our own research and technology platform to help bring you what-->
                        <!--you are looking for.<strong></strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Can I recommend a subject idea for a video?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes, we are always looking for additional topics that will inspire you.-->
                        <!--Please email your suggestions to <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Why are the videos so short?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--We believe big accomplishments are made up of small improvements and that-->
                        <!--lasting change is fueled a few minutes at a time. And we understand you are-->
                        <!--busy and respect your time, so our expert short form videos are easily-->
                        <!--digestible at 3-5 minutes in length.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How often do you post new videos on Tone?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--New videos are posted every week.-->
                    <!--</p>-->
                    <!--<legend>MY ACCOUNT</legend>-->
                    <!--<p>-->
                        <!--<strong>-->
                            <!--What is your privacy policy? Do you share my information with anyone?-->
                        <!--</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Your personal information is never shared with anyone and we take your-->
                        <!--privacy very seriously. Please see our detailed privacy policy <a href="https://tonenetworks.com/privacypolicy" target="_blank">here-->
                    <!--</a>.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Do I get a refund when I disconnect?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--You will not receive a refund for the month in which you disconnect, but-->
                        <!--will not be charged any additional months. Please see our Terms <a href="https://tonenetworks.com/terms" target="_blank">here-->
                    <!--</a>-->
                        <!--.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Why do you charge a subscription fee?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--TONE subscriptions help cover the cost of production, administration,-->
                        <!--technology and marketing costs.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Do you automatically renew my subscription?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes, subscriptions are automatically renewed unless you tell us otherwise.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How do I change my user profile settings or password?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Please go to user settings to change your account information. If you have-->
                        <!--any questions please email <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>-->
                    <!--</p>-->
                    <!--<legend>CLICKS FOR GOOD</legend>-->
                    <!--<p>-->
                        <!--<strong>How do you choose your charities?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--We seek to partner with charities that share our same vision of helping-->
                        <!--women create their best lives and help others do the same.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Can I suggest a charity or cause?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes you may suggest a Clicks for Good cause at <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How does your donation model work?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Clicks for Good is not a profit or revenue based model. As part of doing-->
                        <!--good, Tone automatically puts aside a set amount of donation money for-->
                        <!--Clicks for Good. Individual Clicks For Good charities are given a-->
                        <!--proportion of that amount based on what organization each member selects-->
                        <!--and their level of engagement on Tone. It’s a way for members to give back-->
                        <!--while taking time for themselves with Tone.-->
                    <!--</p>-->
                    <!--<legend>COMMUNITY</legend>-->
                    <!--<p>-->
                        <!--<strong> </strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>How do you choose your TONE Talks?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--We base our TONE Talks on the topics that our members are most passionate-->
                        <!--about. Our TONE Talks create a supportive environment for members to-->
                        <!--explore the topics they care about together.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Can I recommend a TONE Talk or TONE Live subject?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes we are always looking to host talks or live events that are important-->
                        <!--to you. Please send your suggestions to <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>.-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--<strong>Can I apply to be a TONE Talk moderator?</strong>-->
                    <!--</p>-->
                    <!--<p>-->
                        <!--Yes, if you are interested in becoming a Tone Talk moderator please email-->
                        <!--us at <a href="mailto:info@tonenetworks.com">info@tonenetworks.com</a>.-->
                    <!--</p>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE | FAQ',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | FAQ'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | FAQ'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                allFAQ: null,
                contactForm: {
                    emailAddress: '',
                    phoneNumber: '',
                    reason: '',
                    comments: ''
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error', 'user', 'getFAQs', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        mounted: function () {
            let self = this
            self.$store.dispatch('GETFAQS').then(() => {
                if (self.getFAQs) {
                    console.log('faqs', self.getFAQs)
                    self.allFAQ = self.getFAQs
                }
            })
        },
        methods: {
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p strong {
        font-weight: 900;
        color: #000;
    }

    .text-left p {
        font-size: 16px;
    }
    legend {
        color: #f0617d;
    }
    img {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 65%;
    }
</style>



// WEBPACK FOOTER //
// FAQ.vue?76efe25e